import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const greeningWordList = [
  "absorb",
  "anchor",
  "birth",
  "clean",
  "clear",
  "create",
  "drink",
  "emerge",
  "establish",
  "fertile",
  "firm",
  "flourish",
  "form",
  "green",
  "ground",
  "ground",
  "grow",
  "infant",
  "mold",
  "promise",
  "rain",
  "reach",
  "rich",
  "rise",
  "root",
  "shoot",
  "shower",
  "soil",
  "stable",
  "steady",
  "stir",
  "stretch",
  "tender",
  "thrive",
];

export const greeningCollection: WordCollection = createCollection(
  "greening",
  "Greening Earth",
  greeningWordList,
  {
    icon: "sprout",
    isWordlistViewable: true,
    startDate: new Date(new Date().getFullYear(), 2, 1), // March 1st
    endDate: new Date(new Date().getFullYear(), 3, 30), // April 30th
  },
);
